// The scenarios the backend seeds. The keys cross the wire — they are what
// /api/v0/scenario/{scenarioKey}/run names — so a re-key is one edit here.
export const BAKERY_SCENARIO = 'bakery';
export const HAUPTBAHNHOF_SCENARIO = 'hauptbahnhof';

// The scenes they walk. These keys cross the wire too: a run says which scene it is in under one.
export const BAKERY_COUNTER = 'bakery-counter';
export const HAUPTBAHNHOF_TRAVEL_CENTRE = 'hauptbahnhof-travel-centre';
export const HAUPTBAHNHOF_COUNTER = 'hauptbahnhof-counter';
export const HAUPTBAHNHOF_BOARD = 'hauptbahnhof-board';
export const HAUPTBAHNHOF_KIOSK = 'hauptbahnhof-kiosk';
export const HAUPTBAHNHOF_PLATFORM = 'hauptbahnhof-platform';

// What a scene is called wherever the student meets it. The key is the name everywhere else too,
// so a scene nobody has translated yet reads as its key rather than as a missing string.
export const sceneName = (t, sceneKey) => t(`sceneRecord.scenes.${sceneKey}`, sceneKey);

// The list of what there is to play, and the two paths a scenario is played at, shaped like the
// API they call: a door keyed by the scenario, and, once a run has been started, a path that names
// it. The second is what makes a reload a student coming back to the visit they were on rather
// than buying another.
export const SCENARIOS_PATH = '/scenarios';
export const SCENARIO_PATH = `${SCENARIOS_PATH}/:scenarioKey`;
export const SCENARIO_RUN_PATH = `${SCENARIO_PATH}/run/:runId`;

export const scenarioPath = (scenarioKey) =>
  `${SCENARIOS_PATH}/${encodeURIComponent(scenarioKey)}`;

export const scenarioRunPath = (scenarioKey, runId) =>
  `${scenarioPath(scenarioKey)}/run/${encodeURIComponent(runId)}`;
